import React from "react";
import { motion } from "framer-motion";

// Decorative divider with a small wheel icon at center, used above BENDYWHEELS title.
export const LogoOrnament = () => (
  <div className="w-full max-w-lg flex items-center gap-3 justify-center px-4 opacity-90">
    <span className="flex-1 h-px" style={{ backgroundColor: "#FFD400", opacity: 0.4 }} />
    <span className="flex items-center gap-1">
      <span style={{ color: "#FFD400" }}>◆</span>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="#FFD400" strokeWidth="1.5" />
        <circle cx="12" cy="12" r="2" fill="#FFD400" />
        {Array.from({ length: 8 }).map((_, i) => (
          <line
            key={i}
            x1="12"
            y1="12"
            x2="12"
            y2="4"
            stroke="#FFD400"
            strokeWidth="1"
            transform={`rotate(${i * 45} 12 12)`}
          />
        ))}
      </svg>
      <span style={{ color: "#FFD400" }}>◆</span>
    </span>
    <span className="flex-1 h-px" style={{ backgroundColor: "#FFD400", opacity: 0.4 }} />
  </div>
);

export const Logo = () => (
  <motion.h1
    initial={{ opacity: 0, y: -12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase text-center leading-none tracking-[0.02em]"
    style={{ fontFamily: "Orbitron, sans-serif" }}
    data-testid="game-title"
  >
    <span style={{ color: "#FFFFFF" }}>BENDY</span>
    <span
      style={{
        color: "#FFD400",
        textShadow: "0 0 30px rgba(255, 212, 0, 0.35)",
      }}
    >
      WHEELS
    </span>
  </motion.h1>
);

export default Logo;
